import { Component } from '@angular/core';
import { ItemViewContainerBase } from '@fi-app/core/item-view-container-base';
import { AreaModel } from '../area.model';

@Component({
    selector: 'fi-area-view-container',
    template: `<fi-area-view [area]="area"></fi-area-view>`,
    styleUrls: ['./area-view-container.component.scss'],
    standalone: false,
})
export class AreaViewContainerComponent extends ItemViewContainerBase {
    area: AreaModel;
}
